export const GET_ORDER_MESSAGE_HISTORY = "GET_ORDER_MESSAGE_HISTORY"
export const GET_ORDER_MESSAGE_HISTORY_SUCCESS = "GET_ORDER_MESSAGE_HISTORY_SUCCESS"
export const GET_ORDER_MESSAGE_HISTORY_FAIL = "GET_ORDER_MESSAGE_HISTORY_FAIL"